import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../../../axiosinterceptor';

const initialState = {
  healthInsuranceManagerComponentState: {
    selectedRecord: {},
    // showFilterSection: false,
    // isAllEpisodesSelected: false,
    // appliedFilterModal: false,
  },
  healthInsuranceManagerEpisodesPayload: {
    separation_date_from: null,
    separation_date_to: null,
    speciality: [],
    queue: [],
    queue_priority: [],
    status: [],
    coders: [],
    page_number: 1,
    page_size: 10,
    episode_identifier_search: ""
    // page: 1,
  },
  episodeAssignmentPayload: {
    hcp_lines: [],
    assigned_user_id: null,
    select_all: false,
    unchecked_ids : [],
    assigned_queue_id: null,
    is_flagged: false,
  },
  healthInsuranceManagerAssignment: {
  episodeAssignmentLoading: false,
  episodeAssignmentResponse: "",
  episodeAssignmentError: null,
},
  healthInsuranceManagerResponse: {
    healthInsuranceManagerData: [],
    healthInsuranceManagerDataLoading: false,
    healthInsuranceManagerDataError: null,
  },
  healthInsuranceManagerFilters: {
    healthInsuranceManagerFilterOptionsLoading: false,
    healthInsuranceManagerFilterOptionsError: null,
    healthInsuranceManagerFiltersPriority: [],
    healthInsuranceManagerFiltersStatus: [],
  },
  speciality: {
    specialityPageNumber: 0,
    specialityData: [],
    specialityLoading: false,
    specialityError: null,
    isSpecialityPageTrue: true
  },
  users: {
    usersPageNumber: 0,
    usersData: [],
    usersLoading: false,
    usersError: null,
    isUserPageTrue: true
  },
  queue: {
    queuePageNumber: 0,
    queueData: [],
    queueLoading: false,
    queueError: null,
    isQueuePageTrue: true
  },
};

export const getHealthInformationQueueManagerData = createAsyncThunk(
  '/getHealthInformationQueueManagerData',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    try{
      const response = await axiosInstance.post('/codeWorkflowMrnsearchRecommendation', payload);
      if(response.data) {
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error fetching episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)

export const episodeAssignmentCodeWorkflow = createAsyncThunk(
  '/episodeAssignmentCodeWorkflow',
  async(payload, {fulfillWithValue, rejectWithValue}) => {
    // console.log(payload, 'payload')
    try{
      const response = await axiosInstance.post('/test_episode_assignment_code_workflow', payload);
      if(response.data) {
       return fulfillWithValue(response.data)
      }
      // return data; 
    }
    catch(error) {
      console.error('Error Assigning episodes:', error);
      return rejectWithValue(error.response?.data?.message || error.message || "No data found");
      // throw error;
    }
  }
)


export const getHealthInsuranceManagerFilterOptions = createAsyncThunk(
  '/getHealthInsuranceManagerFilterOptions',
  async (_, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/him_dashboard_get_filters_coding_manager_screen_bets");
      // console.log(response, 'data1');
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);

export const specialityOptions = createAsyncThunk(
  '/specialityOptions',
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/him_dashboard_get_speciality_coding_manager?page_number=${pageNumber}`);
      // console.log(response, 'data1');
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);

export const queueOptions = createAsyncThunk(
  '/queueOptions',
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/him_dashboard_get_filters_coding_manager_screen_queue?page_number=${pageNumber}`);
      // console.log(response, 'data1');
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);

export const usersOptions = createAsyncThunk(
  '/usersOptions',
  async (pageNumber, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/him_dashboard_get_filters_coding_manager_screen_users?page_number=${pageNumber}`);
      // console.log(response, 'data1');
      return fulfillWithValue(response.data); // Make sure to return the payload
    } catch (error) {
      console.error('Error fetching filter options:', error);
      // return rejectWithValue(error.response?.data?.message || error.message || "No data found");
    }
  }
);


const healthInsuranceManagerSlicer = createSlice({
  name: "healthInsuranceManager",
  initialState,
  reducers: {
    updateComponentState:(state, action) => {
      state.healthInsuranceManagerComponentState.selectedRecord = action.payload
    },
    updateFilters: (state, action) => {
      state.healthInsuranceManagerEpisodesPayload = {
        ...state.healthInsuranceManagerEpisodesPayload,
        ...action.payload,
      };
    },
    updateAssignmentFilters: (state, action) => {
      state.episodeAssignmentPayload = {
        ...state.episodeAssignmentPayload,
        ...action.payload,
      };
    },
    updateSpecialityPageNumber: (state, action) => {
      state.speciality.specialityPageNumber = action.payload
    },
    updateQueuePageNumber : (state, action) => {
      state.queue.queuePageNumber = action.payload
    },
    updateUserPageNumber : (state, action) => {
      state.users.usersPageNumber = action.payload
    },
    resetEpisodeAssignmentMessage: (state, action) => {
      state.healthInsuranceManagerAssignment.episodeAssignmentResponse = ""
    }
  },
  extraReducers: (builder) => builder
  .addCase(getHealthInformationQueueManagerData.pending, (state) => {
    state.healthInsuranceManagerResponse.healthInsuranceManagerDataLoading = true;
    state.healthInsuranceManagerResponse.healthInsuranceManagerDataError = null;
  }).addCase(getHealthInformationQueueManagerData.fulfilled, (state,action) => {
    state.healthInsuranceManagerResponse.healthInsuranceManagerDataLoading= false;
    state.healthInsuranceManagerResponse.healthInsuranceManagerData = action.payload;
  }).addCase(getHealthInformationQueueManagerData.rejected, (state, action) => {
    state.healthInsuranceManagerResponse.healthInsuranceManagerDataLoading = false;
    state.healthInsuranceManagerResponse.healthInsuranceManagerDataError = action.payload;
  })
  .addCase(getHealthInsuranceManagerFilterOptions.pending, (state) => {
    state.healthInsuranceManagerFilters.healthInsuranceManagerFilterOptionsLoading = true;
    state.healthInsuranceManagerFilters.healthInsuranceManagerFilterOptionsError = null;
  }).addCase(getHealthInsuranceManagerFilterOptions.fulfilled, (state, action) => {
    const options = action.payload;
    state.healthInsuranceManagerFilters.healthInsuranceManagerFilterOptionsLoading= false;
    state.healthInsuranceManagerFilters.healthInsuranceManagerFiltersPriority = options?.priority || [];
    state.healthInsuranceManagerFilters.healthInsuranceManagerFiltersStatus = options?.status || [];
  }).addCase(getHealthInsuranceManagerFilterOptions.rejected, (state, action) => {
    state.healthInsuranceManagerFilters.healthInsuranceManagerFilterOptionsLoading = false;
    state.healthInsuranceManagerFilters.healthInsuranceManagerFilterOptionsError = action.payload;
  })
  .addCase(specialityOptions.pending, (state) => {
    state.speciality.specialityLoading = true;
    state.speciality.specialityError = null;
  }).addCase(specialityOptions.fulfilled, (state, action) => {
    state.speciality.specialityLoading= false;
    // state.speciality.specialityData = action.payload;
    state.speciality.specialityData = [
      ...state.speciality.specialityData,
      ...action.payload?.speciality || []
    ]
    const isValidPage = action.payload ? action.payload?.speciality_still_available : false;
    state.speciality.isSpecialityPageTrue = isValidPage || false;
  }).addCase(specialityOptions.rejected, (state, action) => {
    state.speciality.specialityLoading = false;
    state.speciality.isSpecialityPageTrue = false;
    state.speciality.specialityError = action.payload;
  })
  .addCase(queueOptions.pending, (state) => {
    state.queue.queueLoading = true;
    state.queue.queueError = null;
  }).addCase(queueOptions.fulfilled, (state, action) => {
    state.queue.queueLoading= false;
    // state.queue.queueData = action.payload;
    state.queue.queueData = [
      ...state.queue.queueData,
      ...action.payload?.queues?.queues || []
    ];
    const isValidPage = action.payload?.queues?.queue_name_still_available ?? false;
    state.queue.isQueuePageTrue = isValidPage || false;
  }).addCase(queueOptions.rejected, (state, action) => {
    state.queue.queueLoading = false;
    state.queue.isQueuePageTrue = false
    state.queue.queueError = action.payload;
  })
  .addCase(usersOptions.pending, (state) => {
    state.users.usersLoading = true;
    state.users.usersError = null;
  }).addCase(usersOptions.fulfilled, (state, action) => {
    state.users.usersLoading= false;
    // state.users.usersData = action.payload;
    state.users.usersData = [
      ...state.users.usersData,
      ...action.payload?.queues?.users || []
    ];
    const isValidPage = action.payload?.queues?.user_name_still_available ?? false;
    state.users.isUserPageTrue = isValidPage || false;
  }).addCase(usersOptions.rejected, (state, action) => {
    state.users.usersLoading = false;
    state.users.isUserPageTrue = false;
    state.users.usersError = action.payload;
  })
  .addCase(episodeAssignmentCodeWorkflow.pending, (state) => {
    state.healthInsuranceManagerAssignment.episodeAssignmentLoading = true;
    state.healthInsuranceManagerAssignment.episodeAssignmentError = null;
  }).addCase(episodeAssignmentCodeWorkflow.fulfilled, (state, action) => {
    state.healthInsuranceManagerAssignment.episodeAssignmentLoading = false;
    state.healthInsuranceManagerAssignment.episodeAssignmentResponse = action.payload;
  }).addCase(episodeAssignmentCodeWorkflow.rejected, (state, action) => {
    state.healthInsuranceManagerAssignment.episodeAssignmentLoading = false;
    state.healthInsuranceManagerAssignment.episodeAssignmentError = action.payload;
  })
});

export const { updateFilters, updateSpecialityPageNumber, updateQueuePageNumber, updateUserPageNumber, updateAssignmentFilters, updateComponentState, resetEpisodeAssignmentMessage} = healthInsuranceManagerSlicer.actions;

export default healthInsuranceManagerSlicer.reducer;
